<script setup lang="ts">
    import StatusIconKallelseEjSkapad from "@/assets/actionIcons/status_kallelse_ej_skapad.svg";
    import StatusIconKallelseSkapad from "@/assets/actionIcons/status_kallelse_skapad.svg";
    import StatusIconKallelseSkickad from "@/assets/actionIcons/status_kallelse_skickad.svg";
    import StatusIconKallelseUtskriven from "@/assets/actionIcons/status_kallelse_utskriven.svg";
    import StatusIconSmsBesvarat from "@/assets/actionIcons/status_sms_besvarat.svg";
    import StatusIconSmsEj from "@/assets/actionIcons/status_sms_ej_skickat.svg";
    import StatusIconSmsEjSkickat from "@/assets/actionIcons/status_sms_ej_skickat.svg";
    import StatusIconSmsSkickat from "@/assets/actionIcons/status_sms_skickat.svg";
    import IconList from "@/components/calendars/overlayPanels/IconList/IconList.vue";
    import IconListItem from "@/components/calendars/overlayPanels/IconList/IconListItem.vue";
    import KCell from "@/components/KTable/KCell.vue";
    import { defineProps, toRefs } from "vue";

    const props = defineProps<{
        data: unknown;
    }>();

    const { data } = toRefs(
        props as Readonly<{
            data: {
                status: string;
                smsStatus: "Ej sms" | "Sms skickat" | "Ej skickat" | "Sms besvarat";
                kallelseStatus: "Ej skapad" | "Kallelse skapad" | "Kallelse utskriven" | "Kallelse skickad";
                preliminarbokning: boolean;
            };
        }>
    );

    const getKallelseIcon = () => {
        switch (data.value.kallelseStatus) {
            case "Ej skapad":
                return StatusIconKallelseEjSkapad;
            case "Kallelse skapad":
                return StatusIconKallelseSkapad;
            case "Kallelse utskriven":
                return StatusIconKallelseUtskriven;
            case "Kallelse skickad":
                return StatusIconKallelseSkickad;
        }
    };

    const getSmsIcon = () => {
        switch (data.value.smsStatus) {
            case "Ej sms":
                return StatusIconSmsEj;
            case "Sms skickat":
                return StatusIconSmsSkickat;
            case "Ej skickat":
                return StatusIconSmsEjSkickat;
            case "Sms besvarat":
                return StatusIconSmsBesvarat;
        }
    };
</script>

<template>
    <KCell class="cell-kallelse-sms">
        <template #content>
            <IconList>
                <IconListItem v-if="data.kallelseStatus !== 'Ej skapad'" :icon="getKallelseIcon()" variant="tight">
                    <span>{{ data.kallelseStatus }}</span>
                </IconListItem>
                <IconListItem v-if="data.smsStatus !== 'Ej skickat'" :icon="getSmsIcon()" variant="tight">
                    <span>{{ data.smsStatus }}</span>
                </IconListItem>
            </IconList>
        </template>
    </KCell>
</template>

<style scoped lang="scss">
    .cell-kallelse-sms {
    }
</style>
